<template>
  <div>
    <div>
      <h1 class="text-center">CRM Triggers</h1>
      <div>
        <ListCrmTrigger />
      </div>
    </div>
  </div>
</template>

<script>
import ListCrmTrigger from "./ListCrmTrigger.vue";

export default {
  components: {
    ListCrmTrigger,
  },
};
</script>
